import { AuthenticationResult } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Domains } from "../data/Domains";
import VillageConsoleContext from "../store/VillageConsoleContext";
import { adGroups } from "./adGroups.data";
import { useContext } from "react";


export const useAuth = ( ): {

    authorize(  ): Promise< boolean >
    , getIdToken( ): Promise< string >
    , logout( ) : Promise< void >

} => {

    const { setAvailableDomains, setDomain, setReadonlyDomains } = useContext( VillageConsoleContext );

    const { instance, accounts } = useMsal( );


    const authorize = async ( ): Promise<boolean> => {

        const authenticationResult: AuthenticationResult = await getAuthenticationResult( );
        const groups: string[] = authenticationResult.account?.idTokenClaims?.groups as string[];

        const bmaAdGroupGuid = adGroups.find( m => m.domain === Domains.Bma && !m.readonly )?.guid as string; 
        const niwAdGroupGuid = adGroups.find( m => m.domain === Domains.Niw && !m.readonly )?.guid as string;
        const waioAdGroupGuid = adGroups.find( m => m.domain === Domains.Waio && !m.readonly )?.guid as string;

        const bmaReadOnlyAdGroupGuid = adGroups.find( m => m.domain === Domains.Bma && m.readonly )?.guid as string;
        const niwReadOnlyAdGroupGuid = adGroups.find( m => m.domain === Domains.Niw && m.readonly )?.guid as string;
        const waioReadOnlyAdGroupGuid = adGroups.find( m => m.domain === Domains.Waio && m.readonly )?.guid as string;
  
        const availableDomains: Domains[] = [];
        const readOnlyDomains: Domains[] = [];
        
        if( groups.includes( bmaAdGroupGuid ) || groups.includes( bmaReadOnlyAdGroupGuid ) ) {
  
          availableDomains.push( Domains.Bma );
  
        }
  
        if( groups.includes( niwAdGroupGuid ) || groups.includes( niwReadOnlyAdGroupGuid ) ) {
  
          availableDomains.push( Domains.Niw );
  
        }
  
        if( groups.includes( waioAdGroupGuid ) || groups.includes( waioReadOnlyAdGroupGuid ) ) {
  
          availableDomains.push( Domains.Waio );
  
        }

        if( groups.includes( bmaReadOnlyAdGroupGuid )) {
  
          readOnlyDomains.push( Domains.Bma );
  
        }

        if( groups.includes( niwReadOnlyAdGroupGuid )) {
  
          readOnlyDomains.push( Domains.Niw );
  
        }

        if( groups.includes( waioReadOnlyAdGroupGuid )) {
  
          readOnlyDomains.push( Domains.Waio );
  
        }

        if( readOnlyDomains.length > 0 ) {

          setReadonlyDomains( readOnlyDomains );

        }
        
        if( availableDomains.length > 0 ) {
          
          setAvailableDomains( availableDomains );
          setDomain( availableDomains[ 0 ] );
          return true;
  
        }

        return false;

    }


    const getAuthenticationResult = async( ): Promise<AuthenticationResult> => {

        const tokenRequest = {
          scopes: ['User.Read'],
          account : accounts[0],
          forceRefresh: true
        };

        return await instance.acquireTokenSilent( tokenRequest );
  
    }


    const getIdToken = async( ): Promise< string > => {

      const authenticationResult: AuthenticationResult = await getAuthenticationResult( );
      return authenticationResult.idToken;

    };

    
    const logout = async( ) : Promise< void > => await instance.logout();


    return {

        authorize
        , getIdToken
        , logout

    };

};